import { FormContainer as Container, FormSection as Section } from "../../components";
import { InputField as Input } from "../../components/";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import FormContext from "../../context/FormContext.js";
import { useContext, useEffect } from 'react';

export default function StudentInformationConsent() {
    const { injectFormProps } = useInjectFormProps();
    const { formData, updateFormData } = useContext(FormContext);

    useEffect(() => {
        updateFormData({ "shareStuInfo-consent-prompt": "I confirm that I have read and agreed with the above information." })
    }, [])

    return (
        <Container>{
            injectFormProps(
                <>
                    <Section title={"Consent to Share Student Information"}>
                        <p>
                            We would like your consent to share information about your child.
                        </p>
                        <b>
                            The information that we would like your consent to share is:
                        </b>
                        <ul>
                            <li>student’s first and last name, grade level and age</li>
                            <li>individual or group photos and video</li>
                            <li>art work, writing samples or other student work</li>
                        </ul>
                        <b>
                            We would like your consent to share information about your child.
                        </b>
                        <ol>
                            <li id="school-community-list">
                                EDUCATIONAL PURPOSES IN THE <b>SCHOOL COMMUNITY</b>
                            </li>
                            <ul>
                                <li>school calendar, newsletter or other school publications
                                </li>
                                <li>honour roll, yearbook
                                </li>
                                <li>displays of student work in the school division
                                </li>
                                <li>sharing copies of photos and videos with classmates
                                </li>
                            </ul>
                            <li id="public-media-list">
                                <b>PUBLIC MEDIA INCLUDING THE INTERNET</b>
                            </li>
                            <ul>
                                <li>school division website
                                </li>
                                <li>congratulatory messages for graduation, academic or athletic achievement
                                </li>
                                <li>media interviews
                                </li>
                                <li>photos and video shared with the media
                                </li>
                                <li>displays of student work outside the school division
                                </li>
                            </ul>
                        </ol>
                        <b>
                            If we share any student information we promise to:
                        </b>
                        <ul>
                            <li>check that we have your consent on file
                            </li>
                            <li>consider the privacy interests of your child
                            </li>
                            <li>balance the privacy interests of your child with the educational value for studentssharing the pride of their achievements.
                            </li>
                        </ul>
                        <b>
                            Before we share any information that is not covered by this consent, we will ask for your permission.
                            Please note that:
                        </b>
                        <ul>
                            <li>We are required by law to share personal information of students with the Ministry of Education; and,
                            </li>
                            <li>in some cases we are allowed by law to share personal information of students with other agencies such as Health when it is in the best interest of the child.
                            </li>
                        </ul>
                        <hr />
                        <b>
                            I agree that the Good Spirit School Division may share the information of my child for the following purposes:
                        </b>
                        <Input type={"radiooptions"} inputLabel={"Please select one of the following"} identifier={"shareStuInfoSelected"}
                            options={[{
                                label: "For educational purposes in the school community.",
                                value: "internal"
                            }, {
                                label: "For the public media including the internet.",
                                value: "external"
                            }, {
                                label: <p>For <b>BOTH</b> educational purposes in the school community and the public media including the internet.</p>,
                                value: "both"
                            }, {
                                label: <p>I <b>DO NOT</b> provide consent for sharing information of my child.</p>,
                                value: "none"
                            }]} />

                        <hr />
                        <b>I understand that this consent only needs to be signed once and will cover my child for as long as my child is a student in the Good Spirit School Division.
                        </b>
                        <b>I also understand that if I wish to withdraw my consent, I must contact the principal immediately.
                        </b>
                        <hr />
                        <Input type={"checkbox"} inputLabel={formData["shareStuInfo-consent-prompt"] ?? "somethine went wrong..."} identifier={"shareStuInfo-consent"}></Input>
                    </Section>
                </>
            )}
        </Container>
    );
}
